<script>
    // export let options = ["common", "rare", "epic", "legendary"];
    import { rarityName } from "./rarities";
    export let options = [];
    export let selection = [];

    function toggle(option) {
        const index = selection.indexOf(option);
        if (index === -1) {
            selection.push(option);
            selection = selection;
        } else {
            selection.splice(index, 1);
            selection = selection;
        }
    }
</script>


<div class="options">
    {#each options as option, i (i)}
        <button on:click={() => {toggle(option)}} type="button" class:active={selection.indexOf(option) != -1}>
            {rarityName(option)}
        </button>
    {/each}
</div>


<style>
    .options {
        display: flex;
        gap: 0.5rem;
    }
    
    button {
        cursor: pointer;
        border-radius: 9999rem;
        line-height: 1rem;
        padding: 0.25rem 0.75rem;
        border: 2px solid #e2ddd8;
        background-color: #F5F2EF44;
        color: #bbb5af;
    }

    .active {
        color: #000000CC;
        border-color: #87C777;
        background-color: #87C777;
    }
</style>